var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHazards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 3.31525L14.1475 13.0728H2.8525L8.5 3.31525ZM8.5 0.322754L0.25 14.5728H16.75L8.5 0.322754ZM9.25 10.8228H7.75V12.3228H9.25V10.8228ZM9.25 6.32275H7.75V9.32275H9.25V6.32275Z",
    fill: "#6FCF97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHazards);
export default __webpack_public_path__ + "static/media/hazards.34f95479c427c82f911bdd10a98c2240.svg";
export { ForwardRef as ReactComponent };